import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-navy-light border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-cursive text-4xl text-gold">Noor</span>
              <span className="font-heading text-lg tracking-wider text-beige ml-2 uppercase">Realtor</span>
            </Link>
            <p className="text-beige/60 text-sm leading-relaxed max-w-xs">
              Your trusted partner for premium real estate in South Goa.
              Lands, villas, and luxury apartments curated for the discerning buyer.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-gold font-bold mb-6">Quick Links</h4>
            <div className="space-y-3">
              {[
                { to: "/properties?type=villa", label: "Villas" },
                { to: "/properties?type=flat", label: "Apartments" },
                { to: "/properties?type=land", label: "Land Plots" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Get in Touch" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-beige/60 hover:text-gold transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-gold font-bold mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-gold mt-0.5 shrink-0" />
                <span className="text-sm text-beige/60">South Goa, India</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-gold shrink-0" />
                <a href="tel:+918483918695" className="text-sm text-beige/60 hover:text-gold transition-colors">
                  +91 8483918695
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-gold shrink-0" />
                <span className="text-sm text-beige/60">info@noorrealtor.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-beige/40">
            &copy; {new Date().getFullYear()} Noor Realtor. All rights reserved.
          </p>
          <a
            href="https://wa.me/918483918695"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="text-xs text-gold hover:text-gold-hover transition-colors"
          >
            WhatsApp Us
          </a>
        </div>
      </div>
    </footer>
  );
}
